import classNames from 'classnames'

import { RenderWhen } from 'cng-common/components/renderWhen'
import { Translation } from 'cng-common/features/translations/components/translation'
import { Button } from 'core-components/library/button'
import { Tooltip } from 'core-components/library/tooltip'

import { getFormedEltTranslation } from '../../../helpers/getFormedEltTranslation'

import styles from './RowsControl.module.scss'

interface IProps<T> {
  containerClassName?: string
  addRow?: () => void
  deleteRow?: () => void
  items: T[]
  maxLen?: number
  minLen?: number
  canAddNewRow?: boolean
  showAddNewRow?: boolean
}

const getMessage = (isOverCount: boolean, canAddNewRow?: boolean) => {
  if (isOverCount) {
    return getFormedEltTranslation('table-max')
  }
  if (!canAddNewRow) {
    return getFormedEltTranslation('table-cant-add-new-row')
  }
  return getFormedEltTranslation('table-add-new-row')
}

const getTableAddTooltipContent = (
  isOverCount: boolean,
  canAddNewRow?: boolean,
  maxLen?: number
) => {
  const message = getMessage(isOverCount, canAddNewRow)
  if (isOverCount) {
    return (
      <>
        <Translation text={message} /> {maxLen}
      </>
    )
  }
  return <Translation text={message} />
}
export function RowsControl<T>({
  containerClassName,
  addRow,
  deleteRow,
  items,
  maxLen,
  minLen,
  canAddNewRow,
  showAddNewRow = true,
}: IProps<T>) {
  if (!addRow || !deleteRow) {
    return null
  }
  const itemsLength = items.length
  const isOverCount = !maxLen ? false : itemsLength === maxLen
  const isMinimalCount = !minLen ? false : itemsLength === minLen
  return (
    <div className={classNames(styles.root, containerClassName)}>
      <RenderWhen condition={showAddNewRow}>
        <Tooltip
          className={styles.btnWrapper}
          tipContent={() => getTableAddTooltipContent(isOverCount, canAddNewRow, maxLen)}
          inline
        >
          <Button
            variant={'text'}
            className={styles.btn}
            disabled={isOverCount || !canAddNewRow}
            onClick={addRow}
            iconButton={'kbase kbase-add'}
          />
        </Tooltip>
      </RenderWhen>

      <Tooltip
        className={styles.btnWrapper}
        tipContent={() => <Translation text={getFormedEltTranslation('table-delete-row')} />}
        inline
      >
        <Button
          variant={'text'}
          className={classNames(styles.btn, styles.minusBtn)}
          disabled={itemsLength === 0 || isMinimalCount}
          onClick={deleteRow}
          iconButton={'kbase kbase-minus'}
        />
      </Tooltip>
    </div>
  )
}
